import * as R from 'ramda';


/**
 * Removes the redundant backslashes on escaped quotation marks and newline characters in translation strings returned
 * from the API.
 *
 * @param str A raw HTML string containing repeated backslashes.
 */
export const removeRedundantBackslashes = R.memoizeWith(
  (str: String) => `${str}-deslashed`,
  (str: string) => str
    .replace(new RegExp('\\\\"', 'g'), '"')
    .replace(new RegExp('\\\\n', 'g'), '\n'),
);
